import { Box, Stack } from '@mui/material'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { useEffect } from 'react'

import { useGetInvoiceByIdQuery } from 'store/invoices/invoices.api'

import InvoiceDialogListItem from './invoice-dialog-list-item/invoice-dialog-list-item'
import InvoiceDialogListHeader from './invoice-dialog-list-header/invoice-dialog-list-header'
import { InvoiceDialogProps } from '../invoice.dialog'
import InvoiceDialogListFooter from './invoice-dialog-list-footer/invoice-dialog-list-footer'

const InvoiceDialogList = ({
  handleClose,
}: Omit<InvoiceDialogProps, 'open'>) => {
  const id = useSelector((state: RootState) => state.invoices.selectedInvoiceId)

  const { data: invoice, refetch } = useGetInvoiceByIdQuery({ id })

  useEffect(() => {
    refetch()
  }, [refetch])

  return (
    <Stack justifyContent="space-between" sx={{ height: '100%' }}>
      <Stack>
        <InvoiceDialogListHeader
          userInvoiceId={invoice?.userInvoiceId || ''}
          handleClose={handleClose}
        />
        <Box p={2}>
          {invoice?.events?.map((event) => (
            <InvoiceDialogListItem
              key={event?.id}
              event={event}
              invoiceId={id}
            />
          ))}
        </Box>
      </Stack>
      <InvoiceDialogListFooter invoiceId={id} />
    </Stack>
  )
}

export default InvoiceDialogList
